import { DefaultAppResponse } from 'record-it-time-common/AppResponse';
import { ChangePasswordRequestDto } from 'record-it-time-common/dto/auth/ChangePasswordRequestDto';
import { LoginRequestDto } from 'record-it-time-common/dto/auth/LoginRequestDto';
import { LoginResponseDto } from 'record-it-time-common/dto/auth/LoginResponseDto';
import { ResetPasswordRequestDto } from 'record-it-time-common/dto/auth/ResetPasswordRequestDto';
import { SendPasswordResetMailRequestDto } from 'record-it-time-common/dto/auth/SendPasswordResetMailRequestDto';
import { ExportWorkTimeActivitiesRequestDto } from 'record-it-time-common/dto/export/ExportWorkTimeActivitiesRequestDto';
import { ExportWorkTimeConstructionSiteRequestDto } from 'record-it-time-common/dto/export/ExportWorkTimeConstructionSiteRequestDto';
import { ExportWorkTimeConstructionSiteSummaryRequestDto } from 'record-it-time-common/dto/export/ExportWorkTimeConstructionSiteSummaryRequestDto';
import { ExportWorkTimeCsvRequestDto } from 'record-it-time-common/dto/export/ExportWorkTimeCsvRequestDto';
import { ExportWorkTimeCsvResponseDto } from 'record-it-time-common/dto/export/ExportWorkTimeCsvResponseDto';
import { ExportWorkTimeFullExportRequestDto } from 'record-it-time-common/dto/export/ExportWorkTimeFullExportRequestDto';
import { ExportWorkTimeTimesheetForUserGroupRequestDto } from 'record-it-time-common/dto/export/ExportWorkTimeTimesheetForUserGroupRequestDto';
import { ExportWorkTimeTimesheetRequestDto } from 'record-it-time-common/dto/export/ExportWorkTimeTimesheetRequestDto';
import { CreateUserRequestDto, CreateUserResponseDto } from 'record-it-time-common/dto/synchronization/CreateUserDto';
import { ApiRequester } from '../ApiRequester/ApiRequester';
export class ApiAdapter {
  public static async login(data: LoginRequestDto): Promise<LoginResponseDto> {
    return ApiRequester.postJson('/auth/login', {
      body: data
    });
  }
  public static async createUser(data: CreateUserRequestDto): Promise<CreateUserResponseDto> {
    return ApiRequester.postJson('/user', {
      body: data
    });
  }
  public static async exportWorkTimeCsv(data: ExportWorkTimeCsvRequestDto): Promise<ExportWorkTimeCsvResponseDto> {
    return ApiRequester.postJson('/export/workTime/csv', {
      body: data
    });
  }
  public static async exportWorkTimeTimesheet(data: ExportWorkTimeTimesheetRequestDto): Promise<Blob> {
    return ApiRequester.postFile('/export/workTime/timesheet', {
      body: data
    });
  }
  public static async exportWorkTimeAllTimesheets(data: ExportWorkTimeTimesheetForUserGroupRequestDto): Promise<Blob> {
    return ApiRequester.postFile('/export/workTime/allTimesheetsForUserGroup', {
      body: data
    });
  }
  public static async exportWorkTimeConstructionSite(data: ExportWorkTimeConstructionSiteRequestDto): Promise<Blob> {
    return ApiRequester.postFile('/export/workTime/constructionSite', {
      body: data
    });
  }
  public static async exportWorkTimeConstructionSiteSummary(data: ExportWorkTimeConstructionSiteSummaryRequestDto): Promise<Blob> {
    return ApiRequester.postFile('/export/workTime/constructionSiteSummary', {
      body: data
    });
  }
  public static async exportWorkTimeActivities(data: ExportWorkTimeActivitiesRequestDto): Promise<Blob> {
    return ApiRequester.postFile('/export/workTime/activities', {
      body: data
    });
  }
  public static async exportWorkTimeFullExport(data: ExportWorkTimeFullExportRequestDto): Promise<Blob> {
    return ApiRequester.postFile('/export/workTime/full', {
      body: data
    });
  }
  public static async sendPasswordResetEmail(data: SendPasswordResetMailRequestDto): Promise<DefaultAppResponse> {
    return ApiRequester.postJson('/auth/sendPasswordResetMail', {
      body: data
    });
  }
  public static async resetPassword(data: ResetPasswordRequestDto): Promise<DefaultAppResponse> {
    return ApiRequester.postJson('/auth/resetPassword', {
      body: data
    });
  }
  public static async changePassword(data: ChangePasswordRequestDto): Promise<DefaultAppResponse> {
    return ApiRequester.postJson('/auth/changePassword', {
      body: data
    });
  }
}